import { FC } from 'react'
import { format } from 'date-fns'
import RatingComponent from '../ratings/RatingComponent'
import styles from './ReviewCardComponent.module.scss'
import { Reviews } from 'state/ducks/space/models'

interface Props {
  review: Reviews
  listItemClassName?: string
}

const ReviewCardComponent: FC<Props> = ({ review, listItemClassName }: Props): JSX.Element => {
  return (
    <li className={`${styles.reviewPost} ${listItemClassName ? listItemClassName : ''}`}>
      <div className={styles.user}>
        <img
          className={styles.userImage}
          src={review.review_user.user_image_url || '/user_no_image.webp'}
          alt={review.review_user.first_name || '-'}
        />
        <span className={styles.userName}>{review.review_user.first_name || '-'}</span>
      </div>
      <div className={styles.rating}>
        <RatingComponent averageRating={review.rating} />
        <time className={styles.createdAt}>
          {format(new Date(review.created_at), 'yyyy-MM-dd')}
        </time>
      </div>
      <p className={styles.comment}>{review.comment}</p>
      <p className={styles.userName}></p>
    </li>
  )
}

export default ReviewCardComponent
